import { render, staticRenderFns } from "./ProfileHero.vue?vue&type=template&id=0784cf5c&scoped=true&"
import script from "./ProfileHero.vue?vue&type=script&lang=js&"
export * from "./ProfileHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0784cf5c",
  null
  
)

export default component.exports